export enum UnAuthErrorMessage {
    InvalidTenant = 'denied-invalid-tenant-access',
    DuplicateLogin = 'denied-duplicate-login',
    TokenMismatch = 'denied-token-mismatch',
    SessionExpired = 'denied-session-expired',
    TokenExpired = 'denied-token-invalid',
}
